import { render, staticRenderFns } from "./employer-performance-report-list.vue?vue&type=template&id=2d570256"
import script from "./employer-performance-report-list.vue?vue&type=script&lang=js"
export * from "./employer-performance-report-list.vue?vue&type=script&lang=js"
import style0 from "./employer-performance-report-list.vue?vue&type=style&index=0&id=2d570256&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports